<template>
    <div :class="[ responsive ? 'table-responsive' : ''] ">
        <table class="table" :class="init_table_class" :style="with_action_bar && noOfRecords > 0 && noOfRecords < 3 ? 'min-height:300px;' : ''">
            <thead :class="thead_class">
            <slot name="thead" :locale="locale"/>
            </thead>
            <slot name="tbody" :table_data="table_data" :hasRecords="hasRecords"/>
        </table>
        <modal init_id="ListModal"
               :init_fields="{}"
               :init_title="modal_lang.ListModal ? modal_lang.ListModal.modalTitle : ''"
               ref="ListModal"
        >
            <template slot="body" slot-scope="body">
                {{ modal_lang.ListModal ? modal_lang.ListModal.modalMessage : '' }}
            </template>
            <template slot="footer" slot-scope="footer">
                <div class="modal-footer">
                    <button type="button" class="btn btn-white" data-dismiss="modal">
                        {{ modal_lang.ListModal ? modal_lang.ListModal.modalCancel : '' }}
                    </button>
                    <button type="button" class="btn btn-blue" @click="deleteRecord">
                        {{ modal_lang.ListModal ? modal_lang.ListModal.modalSubmit : '' }}
                    </button>
                </div>
            </template>
        </modal>
    </div>
</template>
<script>
    import plainList from "./PlainList";

    export default {
        mixins: [plainList],
        data() {
            return {}
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Table/PlainListTbody.vue